import { v2SaleContract } from "config";
import { BigNumber } from "ethers";
import { useContractRead } from "wagmi";

const useSalePrice = (): [
  price: BigNumber | undefined,
  readSalePrice: () => void
] => {
  const [{ data: priceData }, readSalePrice] = useContractRead(
    {
      addressOrName: v2SaleContract.address,
      contractInterface: v2SaleContract.interface,
    },
    "price"
  );

  if (priceData === undefined) {
    return [undefined, readSalePrice];
  }

  return [priceData as any as BigNumber, readSalePrice];
};

export default useSalePrice;
